import { FunctionComponent, RefObject, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'

import AddressSearchInput from 'design-system/Inputs/AddressSearchInput'
import Body1 from 'design-system/Typography/Body/Body1'
import Body4 from 'design-system/Typography/Body/Body4'
import Heading2 from 'design-system/Typography/Heading/Heading2'

import Spacer from 'components/Spacer'
import ViewportMarginContainer from 'components/ViewportMarginContainer'

const BackgroundGradient = styled.div`
  background: linear-gradient(96.85deg, #07bff1 19.97%, #1299ec 82.65%);
  color: ${props => props.theme.colors.white};
  width: 100%;
  height: 750px;
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    height: 480px;
  }
  @media (min-width: ${props => props.theme.metrics.desktopLarge}px) {
    height: 410px;
  }
`

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
  }
`

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    max-width: 55%;
  }
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    max-width: 60%;
  }
  @media (min-width: ${props => props.theme.metrics.desktopLarge}px) {
    max-width: 70%;
  }
`

const ImageWrapper = styled.div`
  position: relative;
  width: 300px;
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    position: absolute;
    width: 350px;
    right: 24px;
    transform: translate(0, 5%);
  }
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    width: 400px;
    right: 40px;
    transform: translate(0, 0);
  }
  @media (min-width: ${props => props.theme.metrics.desktopLarge}px) {
    width: 420px;
    right: 0;
    left: 0;
    margin: 0 auto;
    transform: translate(420px, -15%);
  }
`

const Image = styled.img`
  width: 100%;
`

const CustomBreak = styled.br`
  @media (min-width: ${props => props.theme.metrics.desktopLarge}px) {
    display: none;
  }
`
interface IProps {
  getStartedRef?:
    | ((instance: HTMLDivElement | null) => void)
    | RefObject<HTMLDivElement>
    | null
    | undefined
}
const SignUpA: FunctionComponent<IProps> = ({ getStartedRef }) => {
  const theme = useContext(ThemeContext)
  return (
    <>
      <Spacer
        size={theme.spacings[32]}
        hideMobile
        hideTablet
      />
      <BackgroundGradient ref={getStartedRef}>
        <ViewportMarginContainer>
          <LayoutContainer>
            <ContentContainer>
              <Spacer
                size={theme.spacings[32]}
                desktopSize={theme.spacings[72]}
                tabletSize={theme.spacings[56]}
              />
              <Body1 color="white">Sign Up</Body1>
              <Spacer size={theme.spacings[24]} />
              <Heading2 color="white">
                We charge less. <CustomBreak /> You make more.
              </Heading2>
              <Spacer size={theme.spacings[24]} />
              <Body4 color="white">
                Enter your details to create your free listing account today. Savings await...
              </Body4>
              <Spacer
                responsiveSize={theme.spacings[36]}
                size={theme.spacings[56]}
              />
              <AddressSearchInput type="colorTypeB" />
              <Spacer
                size={theme.spacings[32]}
                desktopSize={theme.spacings[72]}
                tabletSize={theme.spacings[56]}
              />
            </ContentContainer>
            <ImageWrapper>
              <Image
                src={`${process.env.CDN_BASE_URL}/q_auto,w_720/amazon/assets/how-it-works/yard-sign-post-shadow.png`}
                alt="HomeLister Yard Sign"
              />
            </ImageWrapper>
          </LayoutContainer>
        </ViewportMarginContainer>
      </BackgroundGradient>
    </>
  )
}

export default SignUpA
